import React from 'react';
import styles from './index.css';
class Tip extends React.PureComponent {
    render() {
        const { content } = this.props;
        return (React.createElement("div", { className: styles.tip_box },
            React.createElement("div", { className: styles.tip }, content)));
    }
}
export default Tip;
